// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_removeMarketingProfileMember(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "MarketingProfileMemberRemoved",
    "NotFoundError",
    "ProfileSettingsChangedError"
  ]);
}

let variablesConverter = {"removeMarketingProfileMemberInput":{},"__root":{"input":{"r":"removeMarketingProfileMemberInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"removeMarketingProfileMember":{"u":"response_removeMarketingProfileMember"}}};

let wrapResponseConverterMap = {
  response_removeMarketingProfileMember: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"removeMarketingProfileMember":{"u":"response_removeMarketingProfileMember"}}};

let responseConverterMap = {
  response_removeMarketingProfileMember: unwrap_response_removeMarketingProfileMember
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connectionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "settingsChangedMessage",
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ProfileSettingsChangedError",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMarketingProfileMemberConnection",
  "kind": "LinkedField",
  "name": "members",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "NotFoundError",
  "abstractKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingProfileMembersListRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeMarketingProfileMember",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "removedMember",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberRemoved",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MarketingProfileMembersListRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeMarketingProfileMember",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "removedMember",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "id",
                    "handleArgs": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "connections.0",
                            "variableName": "connectionId"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "connections"
                      }
                    ]
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberRemoved",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "173ad49ad49cbfb4d5ecfa6d779eff5b",
    "id": null,
    "metadata": {},
    "name": "MarketingProfileMembersListRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation MarketingProfileMembersListRemoveMutation(\n  $input: RemoveMarketingProfileMemberInput!\n) {\n  removeMarketingProfileMember(input: $input) {\n    __typename\n    ... on ProfileSettingsChangedError {\n      settingsChangedMessage: message\n    }\n    ... on MarketingProfileMemberRemoved {\n      removedMember {\n        id\n        nodeId\n      }\n      marketingProfile {\n        members {\n          totalCount\n        }\n        nodeId\n      }\n    }\n    ... on NotFoundError {\n      message\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_removeMarketingProfileMember = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_removeMarketingProfileMember = unwrap_response_removeMarketingProfileMember;
exports.wrap_response_removeMarketingProfileMember = wrap_response_removeMarketingProfileMember;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
